import React from 'react';
import Header from '../Header';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';

function BrokenLinkPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <>
      <Header />
      <Container maxWidth="md">
        <Box
          sx={{
            height: '60vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            flexDirection: 'column',
          }}
        >
          <Typography variant="h1" color="error">
            404
          </Typography>
          <Typography variant="h3" gutterBottom>
            Oops! This link doesn't work.
          </Typography>
          <Button variant="outlined" color="primary" onClick={handleGoHome}>
            Go to Home
          </Button>
        </Box>
      </Container>
    </>
  );
}

export default BrokenLinkPage;
